import React from "react";
import UIButton from "../../../../globalComponents/UIComponents/UIButton";
import { useModalContext } from "../../context/ModalContext";
import PrizeDetailsModal from "./PrizeDetailsModal";
import GetPrizeModal from "./GetPrizeModal";
import { getBalancePointsString } from "../../helpers/prizes-shop";

const className = 'prize-card';

export default ({ prize = {}, user, $locale, userBalance, endingPoints, loadingShopData }) => {

    const { renderModal } = useModalContext();

    const localeName = $locale.name;
    const title = $locale.getProperty(prize, 'title');
    const price = parseInt(prize.price);
    const priceStr = getBalancePointsString({$locale, price: price});
    const photo = prize.images?.[0]?.previewFileUrl;
    const available = prize.inStock ? prize.totalLimit - prize.totalSold : 0;
    const unavailableForUser = prize.unavailableForUser;

    const renderHint = () => {
        let result = "";
        if (!available) {
            result = $locale.get('shop.outOfStock');
        } else if (unavailableForUser) {
            result = $locale.get('shop.limitPerPerson');
        } else if (prize.price > userBalance) {
            result = $locale.get('shop.lackPoints') + " " + (price - userBalance) + " " + String($locale.get('common.point')).toLowerCase() + endingPoints(localeName, price - userBalance, 'genitive');
        }
        return result;
    }

    const renderGetPrizeModal = () => renderModal(GetPrizeModal, { prize, priceStr, title, available, $locale, lockPageScroll: false, });

    return <div className={className} onClick={() => renderModal(PrizeDetailsModal, { prize, priceStr, user, userBalance, loadingShopData, renderHint, $locale, renderGetPrizeModal, lockPageScroll: false, })}>
        <div className={`${className}-image-container`}>
            {photo && <img src={photo} alt={title || ""} />}
        </div>
        <div className={`${className}-available`}>{$locale.get('shop.available')} {available} / {prize.totalLimit}</div>
        <div className={`${className}-title`}><span>{title}</span></div>
        <div className={`${className}-price`}>{priceStr}</div>
        <div className={`${className}-footer`}>
            <UIButton
                color="primary"
                size="large"
                disabled={!user || !available || prize.price > userBalance || unavailableForUser || loadingShopData}
                onClick={(e) => {
                    e.stopPropagation();
                    renderGetPrizeModal()
                }}
            >
                {$locale.get('shop.getPrize')}
            </UIButton>
            {user && <div className={`${className}-hint`}>{renderHint()}</div>}            
        </div>
    </div>
}